import React from 'react'

import { Circle, Container, Label } from './styles'

export interface CardRankingTagProps {
  className?: string
  rank: number
  children?: React.ReactNode
}

export const CardRankingTag: React.FC<CardRankingTagProps> = ({
  className,
  rank,
  children,
}) => {
  // rank が無い(0)場合はタグ自体を描画しない(施設ランキングで上位3件のみバッジ表示するため)
  if (!rank) return null

  return (
    <Container className={className}>
      <Circle>
        No.
        <br />
        {rank}
      </Circle>

      <Label hasContent={!!children}>{children}</Label>
    </Container>
  )
}
